module.exports = __webpack_public_path__ + "img/ic_services_library.b56d56e8.svg";